import endpoints from "static/endpoints";
import api from "app/lib/api";
import { interpolate } from "utils/string";

export const fetchProfile = async () => {
  const response = await api.get(endpoints.auth.profile);

  return response;
};

export const fetchUserList = async () => {
  const response = await api.get(endpoints.users.users);
  return response;
};

export const switchUserRole = async ({
  userId,
  isPrimaryRole,
  account,
  role,
}) => {
  if (!userId) return;

  let url = interpolate(endpoints.users.switchRole, {
    userId,
  });

  let payload = { role, isPrimaryRole };

  if (!isPrimaryRole) {
    payload["account"] = account;
  }

  return await api.put(url, payload);
};
